<template>
  <div class="page-root">
    <form-pf-component></form-pf-component>
  </div>
</template>

<script>
import FormPfComponent from './FormPfComponent.vue';
export default {
  components: { FormPfComponent },
    mounted() {

    if(this.$store.state.auth.user.user_juridica){
      this.tabs= 0
    }else{
      this.tabs = 1

    }
  },
  data: () => ({
    tabs: null,
  }),

};
</script>

<style scoped>
.page-root {
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .page-root { padding: 16px; }
}
</style>

